// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3VXGf","modal":"styles_modal__31vKr","close":"styles_close__2jX6X","details":"styles_details__2Z2Qw","show":"styles_show__1hF4T"};